const getBookingSiteUrl = (companyId) => {
    if (!companyId) return null;
    const baseUrl = process.env.REACT_APP_BOOKING_PUBLIC_URL || "https://softcar-public.netlify.app";
    return `${baseUrl}/${companyId}`;
};

export default getBookingSiteUrl;
